<template>
  <div class="assessor-manual h-100 w-100">
    <div class="header">
      <font-awesome-icon
        :icon="{ prefix: 'far', iconName: 'file' }"
        class="icon__assessor-manual"
      />
      <span class="title__assessor-manual">Assessor Manual</span>
    </div>
    <div class="content__assessor-manual">
      <p class="font-weight-bold">ก่อนที่จะเริ่มการประเมิน คู่มือนี้จะช่วยให้คุณเข้าใจระบบ 4Life</p>
      <p>พร้อมการให้คำแนะนำการประเมินผู้เรียน อย่างมีประสิทธิภาพ</p>
      <p>กดดูรายละเอียดได้เลย</p>
    </div>
    <div class="button-group___assessor-manual">
      <b-button class="button__assessor-manual" variant="primary" @click="onPreviewMethodComponent">
        View Method Components
      </b-button>
      <b-button
        variant="outline-primary"
        size="sm"
        class="button__assessor-manual"
        @click="OnViewPDF"
      >
        <span class="mr-2">View PDF</span>
        <span class="icon__arrow-up-right" aria-label="Open Preview Icon"></span>
      </b-button>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faFile } from '@fortawesome/free-regular-svg-icons';

library.add(faFile);

export default {
  components: {
    FontAwesomeIcon
  },
  props: {
    learningUnitId: {
      type: Number,
      required: true
    }
  },
  methods: {
    OnViewPDF() {
      const url =
        'https://l4life-users-upload-prod.s3.ap-southeast-1.amazonaws.com/Assessor_Manual_on_4_Life_ceb1f3969c.pdf';

      window.open(url, '_blank');
    },

    onPreviewMethodComponent() {
      const previewURL = this.$router.resolve({
        name: 'design-planning/method-components',
        params: {
          learningUnitId: this.learningUnitId
        }
      }).href;

      window.open(previewURL, '_blank');
    }
  }
};
</script>

<style lang="scss" scoped>
.assessor-manual {
  background-color: #f8f9ff;
  border-radius: 8px;
  padding: 12px 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
}

.header {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon__assessor-manual {
  color: #4191ff;
  background-color: #eaf6ff;
  padding: 8px 10px;
  border-radius: 6px;
}

.title__assessor-manual {
  font-weight: 700;
  font-size: 16px;
}

.content__assessor-manual {
  margin: 16px 0;
  font-size: 14px;

  p {
    line-height: 22px;
    margin: 0;
  }
}

.button-group___assessor-manual {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.button__assessor-manual {
  padding: 8px 18px;
  border-radius: 6px;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  flex-wrap: wrap;

  .icon__arrow-up-right {
    background-image: url('~@/assets/icons/arrow-up-right.svg');
    display: inline-block;
    width: 16px;
    height: 16px;
    background-size: cover;
  }

  &:hover .icon__arrow-up-right {
    background-image: url('~@/assets/icons/arrow-up-right-white.svg');
  }
}
</style>
